function encode_emails( options){
    // encode emails 		
    $('[data-encoded-email]').each(function(){
        var link = decodeBase64($(this).data('encoded-email'));
        $(this).attr('href', 'mailto:' + link).text(link);
    })
    
}